import { createSlice } from '@reduxjs/toolkit'

export const CampaignDeliveryStatusFilterSlice = createSlice({
  name: 'campaign_delivery_status_filter',
  initialState: {
    value: '',
  },
  reducers: {
    updateCampaignDeliveryStatus: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { updateCampaignDeliveryStatus } = CampaignDeliveryStatusFilterSlice.actions

export default CampaignDeliveryStatusFilterSlice.reducer